import React from 'react'
import { status_aktif } from '../../constants/general'
import axios from '../../axios';
import FormDropdown from '../../components/FormDropdown'
import Alert from 'react-s-alert'

class FormsGuru extends React.Component {

    constructor() {
        super()
    }

    render() {
        return (
            <div>             
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Nama Lengkap Guru</label>
                    <div className="col-md-10">
                        <input
                            name="guru_nama"
                            type="text"
                            className="form-control"
                            placeholder="Nama Lengkap"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.guru_nama} />
                    </div>
                </div>
				<div>                
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">NIP Guru</label>
                    <div className="col-md-10">
                        <input
                            name="guru_nip"
                            type="text"
                            className="form-control"
                            placeholder="NIP"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.guru_nip} />
                    </div>
                </div>
				<div className="form-group row">
					<label className="col-md-2 form-control-label">REF ID KARTU</label>
                    {localStorage.SISMART_USER_USERNAME === 'root@master.com' ? (

                        <div className="col-md-10">
                            <input
                                name="guru_rfid"
                                type="number"
                                className="form-control"
                                placeholder="Masukkan REF ID Kartu yang valid"
                                onChange={this.props.handleChange}
                                value={this.props.parentState.guru_rfid} />
                        </div>
                        ):(

                        <div className="col-md-10">
                            <input
                                name="guru_rfid"
                                type="number"
                                className="form-control"
                                placeholder="Masukkan REF ID Kartu yang valid"
                                onChange={this.props.handleChange}
                                // disabled={this.props.mode === "Edit"}
                                value={this.props.parentState.guru_rfid} />
                        </div>
                    )}

				</div>                
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">
                        Username
                    </label>
                    <div className="col-md-10">
                        <input 
                            name="guru_username"
                            type="text" 
                            className="form-control" 
                            placeholder="Username untuk login" 
                            onChange={this.props.handleChange} 
                            value={this.props.parentState.guru_username} />                                
                    </div>
                </div> 
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">
                        Password
                    </label>
                    <div className="col-md-10">
                        <input 
                            name="guru_password"
                            type="password"
                            className="form-control" 
                            placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
                            onChange={this.props.handleChange} 
                            value={this.props.parentState.guru_password} />                                
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Status Aktif</label>
                    <div className="col-md-10">
                        <FormDropdown
                            name="guru_status"
                            items={status_aktif}
                            onChange={this.props.handleChange}
                            value={this.props.parentState.guru_status} />
                    </div>
                </div>                                
            </div>
		</div>
        )
    }
};

export default FormsGuru;


// WEBPACK FOOTER //
// ./src/views/Users/FormsGuru.js